import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// MARS — RTH ES, mirrors ANYANWU direction (Grade B/D). Wave 3.
export default function MarsMonitor() { return <EsDeskMonitor system="mars" accent="#ef4444" />; }
